export const analyzeMenuDeprecatedRouteMap = {
  "/customers/:customerId/analytics": "/customers/:customerId/analyze/reports",

  "/customers/:customerId/cloud-diagrams": "/customers/:customerId/analyze/cloud-diagrams",
  "/customers/:customerId/cloud-diagrams/onboarding": "/customers/:customerId/analyze/cloud-diagrams/onboarding",

  "/customers/:customerId/analytics/reports": "/customers/:customerId/analyze/reports",
  "/customers/:customerId/analytics/reports/create": "/customers/:customerId/analyze/reports/create",
  "/customers/:customerId/analytics/reports/:reportId": "/customers/:customerId/analyze/reports/:reportId",
  "/customers/:customerId/analytics/reports/labels": "/customers/:customerId/analyze/reports/labels",
  "/customers/:customerId/analytics/report-templates": "/customers/:customerId/analyze/report-templates",
};
